// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBW4rEuTkRrCvEmBkrU2H__yTEqQUnvRbI",
    authDomain: "my-portfolio-583ea.firebaseapp.com",
    databaseURL: "https://my-portfolio-583ea.firebaseio.com",
    projectId: "my-portfolio-583ea",
    storageBucket: "my-portfolio-583ea.appspot.com",
    messagingSenderId: "18797115170",
    appId: "1:18797115170:web:c0643c28602437dd7f577b",
    measurementId: "G-VWGGM4T94S"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);
const database = firebaseApp.firestore();

export default database;
